import {
  FilterMode,
  WorkAuthorPublisher_OrderBy,
  WorkAuthorPublisher,
  SortOrder,
  WorkAuthorPublisher_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const workAuthorPublisherService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.workAuthorPublisherOne({ id });
    return result.workAuthorPublisherOne as WorkAuthorPublisher;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: WorkAuthorPublisher_OrderBy[] | null = null,
    filter: WorkAuthorPublisher_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: WorkAuthorPublisher_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.workAuthorPublisherListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.workAuthorPublisherListWithOffset
    ) as WorkAuthorPublisher[];
    return { list, orderBy };
  },
};
